import React from 'react';
// import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import SampleGradingForm from './SampleGradingForm.js';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Container
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {children}
    </Container>
  );
}

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
    width: '100%',
    overflow: 'hidden',
  },
}));

export default function SampleGradingTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const sampleArray = Object.keys(props.currentSession);

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  function handleChangeIndex(index) {
    setValue(index);
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="on" //Used this because it wasn't showing
          aria-label="full width tabs example"
        >
          {sampleArray.map((sample,index) => (
            <Tab key={index+3} label={"Amostra " + (index +1) } {...a11yProps(index + 1)} />
          ))}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {sampleArray.map((sample,index) => (
          <TabPanel key={index+1} value={value} index={index} dir={theme.direction}>
            <SampleGradingForm
              name={sample}
              sampleId={sample}
              formState={props.currentSession[sample]}
              handleChange={props.handleChange}
              handleSaveNotes={props.handleSaveNotes}
              handleSubmit={props.handleSubmit}
              userType={props.userType}
              hideForms={props.hideForms}
              saveProgress={props.saveProgress}
            />
          </TabPanel>
        ))}
      </SwipeableViews>
    </div>
  );
}
